import { render, staticRenderFns } from "./approvalContent.vue?vue&type=template&id=410e7f5d&scoped=true"
import script from "./approvalContent.vue?vue&type=script&lang=js"
export * from "./approvalContent.vue?vue&type=script&lang=js"
import style0 from "./approvalContent.vue?vue&type=style&index=0&id=410e7f5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410e7f5d",
  null
  
)

export default component.exports